import { Head } from "@components/seo/Head";
import { Footer, Header } from "@components/ui";
import { useStoreInfoCtx } from "@contexts/StoreInfoContext";
import { AssuranceBadge } from "@pages/payment/components/AssuranceBadge";
import { cn } from "@utils/index";

export default function PageLayout({
  children,
  title,
  description,
  className,
  hideBranding = false,
  showAssuranceBadge = false,
}: {
  children: React.ReactNode;
  title: string;
  description: string;
  className?: string;
  hideBranding?: boolean;
  showAssuranceBadge?: boolean;
}) {
  const { storeInfo } = useStoreInfoCtx();

  const showMerchantBranding = Boolean(storeInfo.logo);

  return (
    <div
      className={cn(
        "flex min-h-screen flex-col",
        showAssuranceBadge && "pt-0",
      )}>
      <Head title={title} description={description} />

      {showAssuranceBadge && <AssuranceBadge />}

      {(!hideBranding || showMerchantBranding) && <Header />}

      <main
        className={cn(
          "mx-auto w-full max-w-2xl flex-1 px-4 py-8 md:max-w-3xl lg:max-w-6xl",
          className,
        )}>
        {children}
      </main>
      <Footer hideBranding={hideBranding} />
    </div>
  );
}
